import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Content } from './SuccessPage/SuccessPage.styles'
import SuccessPage from './SuccessPage/SuccessPage'

export default function ResetPasswordSuccess({
  dataCy,
  OnPasswordRequest,
  isExpiredLink,
  resetLayout
}) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <SuccessPage
      dataCy={dataCy}
      title={
        isExpiredLink
          ? t('login.reset-password')
          : t('login.your-password-has-been-reset')
      }
      onSubmit={() => OnPasswordRequest()}
      resetLayout={resetLayout}
      returnSignInAction={() => {
        navigate('/')
      }}
      isExpiredLink={isExpiredLink}
    >
      <Content>
        {isExpiredLink
          ? t('error.password-expired-message-content')
          : t('login.your-password-has-been-reset-context')}
      </Content>
    </SuccessPage>
  )
}
